"use client";

import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { Button, Link } from "@opensea/next-ui-kit";
import { UnstyledButton } from "@opensea/ui-kit";
import { ContactSupport } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useIntercom } from "@/components/support/IntercomProvider";
import { SUPPORT_URL } from "@/constants/constants";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuSupportItem(t0) {
  const $ = _c(21);
  let isSheet;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = rest;
  } else {
    isSheet = $[1];
    rest = $[2];
  }
  const intercom = useIntercom();
  const t = useTranslations("MoreMenuSupportItem");
  let t1;
  if ($[3] !== isSheet) {
    t1 = isSheet ? <Button icon={ContactSupport} size="lg" variant="secondary" /> : <MoreMenuItemAvatar icon={ContactSupport} />;
    $[3] = isSheet;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <MoreMenuItemContent><MoreMenuItemTitle>{t2}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isSheet || $[10] !== rest || $[11] !== t1 || $[12] !== t3) {
    t4 = <MoreMenuItem isSheet={isSheet} {...rest}>{t1}{t3}</MoreMenuItem>;
    $[9] = isSheet;
    $[10] = rest;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const content = t4;
  if (intercom.isEnabled) {
    let t5;
    if ($[14] !== intercom) {
      t5 = () => {
        track("Intercom support click", {
          inApp: true
        });
        intercom.boot();
        intercom.show();
      };
      $[14] = intercom;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== content || $[17] !== t5) {
      t6 = <UnstyledButton className="w-full" onClick={t5}>{content}</UnstyledButton>;
      $[16] = content;
      $[17] = t5;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    return t6;
  }
  let t5;
  if ($[19] !== content) {
    t5 = <Link href={SUPPORT_URL} onClick={_temp} variant="unstyled">{content}</Link>;
    $[19] = content;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}
function _temp() {
  track("Intercom support click", {
    inApp: false
  });
}